module.exports = __webpack_public_path__ + "static/media/verified-email-icon.6ad7c5e1.svg";